import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { frontendURL } from '../../../helper/URLHelper';

import WizardPageRouteView from './pages/WizardPageRouteView.vue';
import AssistantsIndexPage from './pages/AssistantsIndexPage.vue';
import AssistantEmptyStateIndex from './assistants/Index.vue';

import AssistantSettingsIndex from './assistants/settings/Settings.vue';
import AssistantInboxesIndex from './assistants/inboxes/Index.vue';
import AssistantPlaygroundIndex from './assistants/playground/Index.vue';
import AssistantGuardrailsIndex from './assistants/guardrails/Index.vue';
import AssistantGuidelinesIndex from './assistants/guidelines/Index.vue';
import AssistantScenariosIndex from './assistants/scenarios/Index.vue';
import DocumentsIndex from './documents/Index.vue';
import ResponsesIndex from './responses/Index.vue';
import ResponsesPendingIndex from './responses/Pending.vue';
import CustomToolsIndex from './tools/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.WIZARD,
};

const metaV2 = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.WIZARD_V2,
};

const assistantRoutes = [
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/faqs'),
    component: ResponsesIndex,
    name: 'wizard_assistants_responses_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/documents'),
    component: DocumentsIndex,
    name: 'wizard_assistants_documents_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/tools'),
    component: CustomToolsIndex,
    name: 'wizard_tools_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/scenarios'),
    component: AssistantScenariosIndex,
    name: 'wizard_assistants_scenarios_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/playground'),
    component: AssistantPlaygroundIndex,
    name: 'wizard_assistants_playground_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/inboxes'),
    component: AssistantInboxesIndex,
    name: 'wizard_assistants_inboxes_index',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/faqs/pending'),
    component: ResponsesPendingIndex,
    name: 'wizard_assistants_responses_pending',
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:assistantId/settings'),
    component: AssistantSettingsIndex,
    name: 'wizard_assistants_settings_index',
    meta,
  },
  // Settings sub-pages (guardrails and guidelines)
  {
    path: frontendURL(
      'accounts/:accountId/wizard/:assistantId/settings/guardrails'
    ),
    component: AssistantGuardrailsIndex,
    name: 'wizard_assistants_guardrails_index',
    meta: metaV2,
  },
  {
    path: frontendURL(
      'accounts/:accountId/wizard/:assistantId/settings/guidelines'
    ),
    component: AssistantGuidelinesIndex,
    name: 'wizard_assistants_guidelines_index',
    meta: metaV2,
  },
  {
    path: frontendURL('accounts/:accountId/wizard/assistants'),
    component: AssistantEmptyStateIndex,
    name: 'wizard_assistants_create_index',
    meta: {
      permissions: ['administrator', 'agent'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/wizard/:navigationPath'),
    component: AssistantsIndexPage,
    name: 'wizard_assistants_index',
    meta,
  },
];

/** Bookmarks and old links used `/captain/...` before the Wizard rebrand. */
export const legacyWizardAssistantRedirectRoutes = [
  {
    path: '/app/accounts/:accountId/captain/:pathMatch(.*)*',
    redirect: to => {
      const { accountId, pathMatch } = to.params;
      const tail = pathMatch
        ? `/${Array.isArray(pathMatch) ? pathMatch.join('/') : pathMatch}`
        : '';
      return {
        path: `/app/accounts/${accountId}/wizard${tail}`,
        query: to.query,
        hash: to.hash,
      };
    },
  },
];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/wizard'),
    component: WizardPageRouteView,
    redirect: to => {
      return {
        name: 'wizard_assistants_index',
        params: {
          navigationPath: 'wizard_assistants_responses_index',
          ...to.params,
        },
      };
    },
    children: [...assistantRoutes],
  },
];
